import React, { useEffect, useState } from "react";
interface RemainTimeCounterProps {
    time: number;
}
function RemainTimeCounter({ time }: RemainTimeCounterProps) {
    const [curTime, setCurTime] = useState(time);
    useEffect(() => {
        setInterval(() => {
            setCurTime((ex) => ex - 1000);
        }, 1000);
    }, []);
    const ss = Math.round(curTime / 1000);
    const mm = Math.floor(ss / 60);
    if (curTime < 0) return <div>Overdue</div>;
    return <div>{`${mm}m${ss - mm * 60}s`}</div>;
}

export default RemainTimeCounter;
